export const SHOW_FLYOUT = 'SHOW_FLYOUT';
export const HIDE_FLYOUT = 'HIDE_FLYOUT';
export const SET_FLYOUT_TITLE = 'SET_FLYOUT_TITLE';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const CLEAN_FILTERS = 'CLEAN_FILTERS';
